<template>
    <CRow>
        <CCol col="12" xl="12">
            <transition name="slide">
                <CCard>
                    <CCardBody>
                        <div class="row d-flex justify-content-end mr-0 mb-3">
                            <div class="col-auto pr-0 pl-0">
                                <CButton v-if="permissions.reports.add" color="success" @click="createRepor()">
                                    <CIcon :content="$options.addIcon" /> {{ $t('button.create') }} {{ $t('reports.label') }}
                                </CButton>
                            </div>
                        </div>
                        <CDataTable
                            :items="filteredItems"
                            :fields="fields"
                            :items-per-page="perPage"
                            :itemsPerPageSelect="itemsPerPage"
                            :tableFilter="tableFilter"
                            :table-filter-value.sync="search"
                            :loading="loading"
                            addTableClasses="d-print-table table-dropdown-fix"
                            hover
                            sorter
                            pagination
                        >
                            <template #report_type="{item}">
                                <td>
                                    <CBadge >{{ item.type }}</CBadge>
                                </td>
                            </template>
                            <template #driver="{item}">
                                <td>
                                    <CBadge >{{ item.driver }}</CBadge>
                                </td>
                            </template>
                            <template #registered="{item}">
                                <td>
                                    <CBadge >{{ item.created }}</CBadge>
                                </td>
                            </template>
                            <template #options="{item}">
                                <td>
                                    <CDropdown
                                        :toggler-text="$t('button.options')" 
                                        class="m-2"
                                    >
                                        <CDropdownItem @click="exportFile(item)">{{ $t('export') }}</CDropdownItem>
                                    </CDropdown>
                                </td>
                            </template>
                        </CDataTable>
                    </CCardBody>
                </CCard>
            </transition>
        </CCol>


        <div id="reporteContenido"  style='min-width:1150px' v-show="visibleReport">
            <vue-html2pdf
                :show-layout="false"
                :float-layout="false"
                :enable-download="true"
                :preview-modal="false"
                :paginate-elements-by-height="1400"
                filename="report"
                :pdf-quality="2"
                :manual-pagination="false"
                pdf-format="a4"
                pdf-orientation="landscape"
                pdf-content-width="1125px"
                ref="html2Pdf"
            >
                <section slot="pdf-content">
                    <CCol col="12">
                        <CCol col="12" class="font-weight-bold">
                            <table style="width: 100%;">
                                <tr>
                                    <td style="width: 80%;">Blue Star</td>                            
                                    <td style="width: 20%;">
                                        <table>
                                            <tr>
                                                <td style="width: 100px;">INITIAL DATE:</td>                            
                                                <td>{{initDate}}</td>                            
                                            </tr>
                                            <tr>
                                                <td>FINAL DATE:</td>                            
                                                <td>{{endDate}}</td>                            
                                            </tr>
                                        </table>
                                    </td>                            
                                </tr>
                            </table>
                        </CCol>
                        <CCol col="12" class="bg-warning text-center font-weight-bold border border-dark">
                            <label>REPORTE</label>
                        </CCol>
                        <CCol col="12">
                            <table style="width: 100%;">
                                <thead>
                                    <tr class="text-center font-weight-bold border border-dark">
                                        <th class="bg-warning border border-dark" style="width: 260px; height: 70px;">DELIVERY TYPE</th>
                                        <th class="bg-info border border-dark" style="width: 90px; height: 70px;">PENDIENTE</th>
                                        <th class="bg-info border border-dark" style="width: 90px; height: 60px;">CASH</th>
                                        <th class="bg-info border border-dark" style="width: 90px; height: 60px;">TARJETA</th>
                                        <th class="bg-info border border-dark" style="width: 90px; height: 60px;">CHEQUE</th>
                                        <th class="bg-info border border-dark" style="width: 90px; height: 70px;">NO CONTESTO</th>
                                        <th class="bg-danger border border-dark" style="width: 90px; height: 70px;">TOTAL CREDITS (PENDING PAYMENTS)</th>
                                        <th class="bg-warning border border-dark" style="width: 90px; height: 70px;">QUANTITY DELIVERY TYPE</th>
                                        <th class="bg-warning border border-dark" style="width: 90px; height: 70px;">TOTAL SOLD</th>
                                        <th class="bg-success border border-dark" style="width: 90px; height: 70px;">TOTAL GENERAL</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="text-center font-weight-bold border border-dark"
                                        v-for="(data, index) in dataReport.products" :key="index">
                                        <td :class="((data.product === 'TOTALES GENERALES') ? 'bg-success border border-dark' : 'bg-warning border border-dark')">
                                            {{data.product}}
                                        </td>
                                        <td :class="((data.product === 'TOTALES GENERALES') ? 'bg-success border border-dark' : 'border border-dark')">
                                            {{formatPrice(data.payments[0].price)}}
                                        </td>
                                        <td :class="((data.product === 'TOTALES GENERALES') ? 'bg-success border border-dark' : 'border border-dark')">
                                            {{formatPrice(data.payments[1].price)}}
                                        </td>
                                        <td :class="((data.product === 'TOTALES GENERALES') ? 'bg-success border border-dark' : 'border border-dark')">
                                            {{formatPrice(data.payments[2].price)}}
                                        </td>
                                        <td :class="((data.product === 'TOTALES GENERALES') ? 'bg-success border border-dark' : 'border border-dark')">
                                            {{formatPrice(data.payments[4].price)}}
                                        </td>
                                        <td :class="((data.product === 'TOTALES GENERALES') ? 'bg-success border border-dark' : 'border border-dark')">
                                            {{formatPrice(data.payments[5].price)}}
                                        </td>
                                        <td :class="((data.product === 'TOTALES GENERALES') ? 'bg-success border border-dark' : 'border border-dark')">
                                            {{formatPrice(data.payments[6].price)}}
                                        </td>
                                        <td :class="((data.product === 'TOTALES GENERALES') ? 'bg-success border border-dark' : 'border border-dark')">
                                            {{data.quantity}}
                                        </td>
                                        <td :class="((data.product === 'TOTALES GENERALES') ? 'bg-success border border-dark' : 'border border-dark')">
                                            {{formatPrice(data.totalSold)}}
                                        </td>
                                        <td :class="((data.product === 'TOTALES GENERALES') ? 'bg-success border border-dark' : 'border border-dark')">
                                            {{formatPrice(data.totalGeneral)}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </CCol>
                        <CCol col="12" class="bg-warning text-center font-weight-bold border border-dark">
                            <label>OTHERS</label>
                        </CCol>
                        <CCol col="12">
                            <CRow>
                                <CCol col="4">
                                    <CCol col="12" class="bg-danger text-center font-weight-bold border border-dark">
                                        <label>EXPENSES</label>
                                    </CCol>
                                    <CCol col="12">
                                        <table style="width: 100%;">
                                            <tr class="text-center font-weight-bold border border-dark">
                                                <td class="bg-danger border border-dark">EXPENSES TYPE</td>
                                                <td class="bg-danger border border-dark">AMOUNT</td>
                                            </tr>

                                            <tr class="text-center font-weight-bold border border-dark"
                                                v-for="(data, index) in dataReport.expenses" :key="index">
                                                <td class="border border-dark">
                                                    {{data.name}}
                                                </td>
                                                <td class="border border-dark">
                                                    {{formatPrice(data.cantidad)}}
                                                </td>
                                            </tr>
                                        </table>
                                    </CCol>
                                </CCol>
                                <CCol :col="{ offset:'4', size: '4' }">
                                    <CCol col="12" class="bg-success text-center font-weight-bold border border-dark">
                                        <label>TOTALES GENERALES Y GANANCIA NETO</label>
                                    </CCol>
                                    <CCol col="12">
                                        <table style="width: 100%;">
                                            <tr class="text-center font-weight-bold border border-dark">
                                                <td class="bg-success border border-dark">NAMES</td>
                                                <td class="bg-success border border-dark">QUANTITY</td>
                                            </tr>

                                            <tr class="text-center font-weight-bold">
                                                <td class="border border-dark">
                                                    EXPENSE
                                                </td>
                                                <td class="border border-dark">
                                                    {{(dataReport.totalesGenerales) ? formatPrice(dataReport.totalesGenerales.expenses) : formatPrice(0)}}
                                                </td>
                                            </tr>
                                            <tr class="text-center m-1 font-weight-bold">
                                                <td class="border border-dark">
                                                    CHEQUES
                                                </td>
                                                <td class="border border-dark">
                                                    {{(dataReport.totalesGenerales) ? formatPrice(dataReport.totalesGenerales.cheques) : formatPrice(0)}}
                                                </td>
                                            </tr>
                                            <tr class="text-center m-1 font-weight-bold">
                                                <td class="border border-dark">
                                                    TARGETAS
                                                </td>
                                                <td class="border border-dark">
                                                    {{(dataReport.totalesGenerales) ? formatPrice(dataReport.totalesGenerales.tarjeta) : formatPrice(0)}}
                                                </td>
                                            </tr>
                                            <tr class="text-center m-1 font-weight-bold">
                                                <td class="border border-dark">
                                                    CREDITOS
                                                </td>
                                                <td class="border border-dark">
                                                    {{(dataReport.totalesGenerales) ? formatPrice(dataReport.totalesGenerales.credito) : formatPrice(0)}}
                                                </td>
                                            </tr>
                                            <tr class="text-center m-1 font-weight-bold">
                                                <td class="border border-dark">
                                                    CASH
                                                </td>
                                                <td class="border border-dark">
                                                    {{(dataReport.totalesGenerales) ? formatPrice(dataReport.totalesGenerales.cash) : formatPrice(0)}}
                                                </td>
                                            </tr>
                                            <tr class="text-center m-1 font-weight-bold">
                                                <td class="border border-dark">
                                                    NO CONTESTO
                                                </td>
                                                <td class="border border-dark">
                                                    {{(dataReport.totalesGenerales) ? formatPrice(dataReport.totalesGenerales.nocontesto) : formatPrice(0)}}
                                                </td>
                                            </tr>
                                            <tr class="text-center m-1 font-weight-bold">
                                                <td class="border border-dark">
                                                    TOTALES
                                                </td>
                                                <td class="border border-dark">
                                                    {{(dataReport.totalesGenerales) ? formatPrice(dataReport.totalesGenerales.totales) : formatPrice(0)}}
                                                </td>
                                            </tr>
                                        </table>
                                    </CCol>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CCol>
                </section>
            </vue-html2pdf>
        </div>
    </CRow>
</template>

<script>
import jsPDF from 'jspdf' 
import axios from 'axios';
import i18n from "../../i18n";
import { mapState } from 'vuex';
import listMixin from '../../mixins/list';
import html2canvas from "html2canvas"
import localeMixin from '../../mixins/locale';
import {cilPlus, cilPrint, cilDataTransferUp } from '@coreui/icons';
import VueHtml2pdf from 'vue-html2pdf'

export default {
    name: 'Reports',
    mixins: [listMixin, localeMixin],
    printIcon: cilPrint,
    addIcon: cilPlus,
    exportIcon: cilDataTransferUp,
    data() {
        return {
            visibleReport:false,
            initDate:"",
            endDate:"",
            items: [],
            dataReport: [],
            fields: [
                'report_type',
                'driver', 
                'registered', 
                'generate_by', 
                {
                    key: 'options',
                    label: i18n.t('button.options'),
                    sorter: false,
                    filter: false
                }],
                tableFilter: {
                    label: i18n.t('search'),
                    placeholder: i18n.t('clients.search_placeholder'),
                    lazy: false,
                    external: true
                },
                tableOptions: {
                    sorter: true,
                    pagination: true,
                    tableFilter: {
                        label: i18n.t('search'),
                        placeholder: i18n.t('clients.search_placeholder'),
                        lazy: false,
                        external: true
                    }
                }
        }
    },
    mounted() {
        this.getReports();
    },
    components: {
        VueHtml2pdf
    },
    computed: {
        ...mapState({
            permissions: state => state.permissions,
        }),
            filteredItems() {
                return this.items.filter(i => {
                    console.log(this.search.toLowerCase());
                    console.log(i);
                    var fil = i.type.toLowerCase().includes(this.search.toLowerCase()) || 
                        i.driver.includes(this.search.toLowerCase());
                    console.log(fil);
                    return fil;
                });
            }
    },
    methods: {
        generateReport() {
            this.$refs.html2Pdf.generatePdf()
        },
        formatPrice(value) {
            let val = (value/1).toFixed(2).replace(',', '.')
            return "$"+val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        createRepor() {
            this.$router.push({ name: 'FormReport'});
        },
        printData() {
            let url = '/api/reports/print?token=' + localStorage.getItem("api_token") + '&results=' + this.perPage;
            window.open(url);
        },
        exportFile(item) {
            let self = this;

            if (item.generate_by_driver === 0) {
                self.initDate = item.date_init;
                self.endDate = item.date_end;
                axios({
                    url: '/api/pdf/reports?token=' + localStorage.getItem("api_token"),
                    data: item,
                    method: 'POST',
                }).then(response => {
                    self.dataReport = response.data;
                    self.visibleReport = true;
                    setTimeout(function() {
                        self.generateReport();
                    }, 500)
                });
            } else {
                axios({ 
                    url: '/api/export/reports?token=' + localStorage.getItem("api_token"),
                    data: item,
                    method: 'POST',
                    responseType: 'blob'
                }).then(response => {
                    const fileUrl = window.URL.createObjectURL(new Blob([response.data]));
                    const fileLink = document.createElement('a');
                    fileLink.href = fileUrl;
                    fileLink.setAttribute('download', 'reports.xls');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                });
            }
        },
        showReport(id) {
            this.$router.push({ name: 'Report', params: {id} });
        },
        deleteReport(id) {
            this.$swal({
                title: i18n.t('report.modal.delete_label'),
                html: i18n.t('report.modal.delete_body'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: i18n.t('button.accept')
            }).then(result => {
                if (result.value) {
                    // do delete request
                    axios.delete('/api/report/'+ id,
                                 {
                                     headers: {
                                         'Authorization': `Bearer ${localStorage.getItem("api_token")}` 
                                     }
                                 })
                                 .then(response => {
                                     this.$swal(
                                         i18n.t('report.modal.updated_label'),
                                         i18n.t('report.modal.updated_body'),
                                         'success'
                                     );
                                     this.getReports();
                                 });
                }
            });
        },
        getReports() {
            let self = this;

            axios.get('/api/report',
                      {
                          headers: {
                              'Authorization': `Bearer ${localStorage.getItem("api_token")}` 
                          }
                      })
                      .then(response => {
                          self.items = response.data;
                      }).catch(error => {
                          console.log(error);
                          this.$router.push({ path: '/login' });
                      });
        },
        exportPDF() {
            let self = this;
            const doc = new jsPDF('l');
            /** WITH CSS */
            html2canvas(document.getElementById("reporteContenido"), { 
                scrollX: 0,
                scrollY: -window.scrollY
            }).then(function (canvas) {
                const img = canvas.toDataURL("image/jpeg");
                doc.addImage(img,'JPEG',2,0);
                doc.save("reporte.pdf");
                self.visibleReport = false;
            });
        }
    }
}
</script>
